import { Outlet } from 'react-router-dom';

import { AuthProvider } from '@/auth/auth-provider';

/**
 * The router's root element.
 *
 * `AuthProvider` is here rather than in `providers.tsx` because it needs the
 * router (it navigates on session expiry) and `RouterProvider` cannot be nested
 * inside its own descendants.
 */
export function Root() {
  return (
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  );
}
